module.exports = __webpack_public_path__ + "assets/img/usa-news-active.1acef8b3.svg";